document.addEventListener('DOMContentLoaded', function() {
  function getSafeRedirectPath(rawUrl) {
    if (!rawUrl || typeof rawUrl !== 'string') return '';
    try {
      const resolved = new URL(rawUrl, window.location.origin);
      const isHttp = resolved.protocol === 'http:' || resolved.protocol === 'https:';
      if (!isHttp || resolved.origin !== window.location.origin) return '';
      return resolved.pathname + resolved.search + resolved.hash;
    } catch (error) {
      return '';
    }
  }

  // Handler for Order Now button clicks
  document.addEventListener('click', async function(e) {
    const orderNowBtn = e.target.closest('.order-now-btn');
    
    if (orderNowBtn) {
      e.preventDefault();
      window.__etFulfillmentPostRedirectUrl = getSafeRedirectPath(orderNowBtn.href);

      const gate = window.EtFulfillmentGate;
      if (!gate || typeof gate.validateForAction !== 'function') {
        if (typeof openDeliveryModal === 'function') {
          openDeliveryModal();
        }
        return;
      }

      let validationResult;
      try {
        validationResult = await gate.validateForAction();
      } catch (error) {
        console.error('Order Now: fulfillment validation error', error);
      }

      if (!validationResult || validationResult.ok !== true) {
        if (typeof openDeliveryModal === 'function') {
          openDeliveryModal();
        }
        return;
      }
      
      // Navigate to the original destination
      window.__etFulfillmentPostRedirectUrl = '';
      window.location.href = orderNowBtn.href;
    }
  });
});
